var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 128,
    viewBox: "0 0 113 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 97,
    height: 122,
    rx: 12,
    fill: "#B4B4B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 94,
    height: 122,
    rx: 12,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 86,
    height: 43,
    rx: 12,
    fill: "#D62828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.496 83.576C31.496 84.7707 31.208 85.8907 30.632 86.936C30.0773 87.9813 29.192 88.824 27.976 89.464C26.7813 90.104 25.2667 90.424 23.432 90.424H19.688V99H15.208V76.664H23.432C25.16 76.664 26.632 76.9627 27.848 77.56C29.064 78.1573 29.9707 78.9787 30.568 80.024C31.1867 81.0693 31.496 82.2533 31.496 83.576ZM23.24 86.808C24.4773 86.808 25.3947 86.5307 25.992 85.976C26.5893 85.4 26.888 84.6 26.888 83.576C26.888 81.4 25.672 80.312 23.24 80.312H19.688V86.808H23.24ZM42.4848 76.664C44.8314 76.664 46.8901 77.1227 48.6608 78.04C50.4528 78.9573 51.8288 80.2693 52.7888 81.976C53.7701 83.6613 54.2608 85.624 54.2608 87.864C54.2608 90.104 53.7701 92.0667 52.7888 93.752C51.8288 95.416 50.4528 96.7067 48.6608 97.624C46.8901 98.5413 44.8314 99 42.4848 99H34.6768V76.664H42.4848ZM42.3248 95.192C44.6714 95.192 46.4848 94.552 47.7648 93.272C49.0448 91.992 49.6848 90.1893 49.6848 87.864C49.6848 85.5387 49.0448 83.7253 47.7648 82.424C46.4848 81.1013 44.6714 80.44 42.3248 80.44H39.1568V95.192H42.3248ZM71.4062 76.664V80.28H62.0943V86.008H69.2303V89.56H62.0943V99H57.6143V76.664H71.4062Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2e1d5db2dd07139a7b4da3588ff38621.svg";
export { ForwardRef as ReactComponent };